(() => {
  const selector = '.muy-becoming-products';

  function familyFor(card) {
    const title = (card.dataset.title || '').trim();
    const beforeColor = title.split(/\s+-\s+/)[0];
    const words = beforeColor.split(/\s+/);
    return (beforeColor !== title ? beforeColor : words.slice(0, 2).join(' ')).toLowerCase();
  }

  function arrange(cards, priorityHandles) {
    const priority = new Map(priorityHandles.map((handle, index) => [handle, index]));
    const remaining = cards
      .map((card, index) => ({ card, index, family: familyFor(card) }))
      .sort((a, b) => (priority.get(a.card.dataset.handle) ?? 10000) - (priority.get(b.card.dataset.handle) ?? 10000) || a.index - b.index);
    const arranged = [];

    while (remaining.length) {
      const previousFamily = arranged.at(-1)?.family;
      const nextIndex = remaining.findIndex(item => item.family !== previousFamily);
      arranged.push(remaining.splice(Math.max(nextIndex, 0), 1)[0]);
    }

    arranged.forEach(item => {
      item.card.dataset.family = item.family;
    });
    return arranged.map(item => item.card);
  }

  function init(section) {
    if (section.dataset.initialized === 'true') return;
    const rail = section.querySelector('.muy-becoming-products__rail');
    const progress = section.querySelector('.muy-becoming-products__progress');
    const next = section.querySelector('.muy-becoming-products__next');
    const counter = section.querySelector('.muy-becoming-products__counter');
    const cards = [...rail.querySelectorAll('.muy-becoming-products__card')];
    if (!cards.length) return;

    const priority = (section.dataset.featuredOrder || '').split(',').map(value => value.trim()).filter(Boolean);
    rail.append(...arrange(cards, priority));
    rail.scrollLeft = 0;
    section.dataset.initialized = 'true';

    function update() {
      const maxScroll = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const ratio = maxScroll ? rail.scrollLeft / maxScroll : 0;
      progress.value = Math.round(ratio * 1000);
      progress.disabled = !maxScroll;
      const firstCard = cards[0];
      const railStyle = getComputedStyle(rail);
      const gap = parseFloat(railStyle.gap || 0);
      const step = firstCard.getBoundingClientRect().width + gap;
      const first = Math.min(cards.length, Math.max(1, Math.round(rail.scrollLeft / step) + 1));
      const contentWidth = rail.clientWidth - parseFloat(railStyle.paddingLeft || 0) - parseFloat(railStyle.paddingRight || 0);
      const visible = Math.max(1, Math.floor((contentWidth + gap + 2) / step));
      const last = Math.min(cards.length, first + visible - 1);
      counter.textContent = String(first).padStart(2, '0') + ' – ' + String(last).padStart(2, '0') + ' / ' + cards.length;
      next.disabled = !maxScroll || rail.scrollLeft >= maxScroll - 2;
    }

    let frame;
    rail.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    progress.addEventListener('input', () => {
      rail.scrollLeft = (rail.scrollWidth - rail.clientWidth) * Number(progress.value) / 1000;
    });
    next.addEventListener('click', () => {
      const cardWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(rail).gap || 0);
      rail.scrollBy({ left: cardWidth + gap, behavior: 'smooth' });
    });
    requestAnimationFrame(() => {
      rail.scrollLeft = 0;
      update();
    });
  }

  document.querySelectorAll(selector).forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll(selector).forEach(init);
  });
})();
